import { apiService } from './api.service';
import { API_ENDPOINTS } from '../config/api';

export interface Cotizacion {
    id: string;
    numero: string;
    fecha: string;
    proveedor?: string;
    requisicion?: string; // Added to match page
    items: number;
    total: number;
    validezDias?: number; // Added to match page
    estado: string;
}

export const cotizacionesService = {
    getAll: async () => {
        return apiService.get<Cotizacion[]>(API_ENDPOINTS.COTIZACIONES_LIST);
    },

    save: async (data: any) => {
        return apiService.post(`${API_ENDPOINTS.COTIZACIONES}/save`, data);
    },

    asignarProveedores: async (idCotizacion: string, providerIds: string[], userAsigna: string) => {
        return apiService.post('/cotizaciones/asignar', {
            id_cotizacion: idCotizacion,
            proveedores: providerIds.map(id => ({ id_proveedor: id })),
            user_asigna: userAsigna
        });
    },

    getProveedoresAsignados: async (idCotizacion: string) => {
        return apiService.get<any[]>('/cotizaciones/proveedores', true, {
            params: {
                id_cotizacion: idCotizacion
            }
        });
    },

    // New methods for "Completar Valores"
    getDetalleCotizacion: async (idCotizacion: string) => {
        return apiService.get<any>(API_ENDPOINTS.COTIZACIONES_DETALLE, true, {
            params: {
                id: idCotizacion
            }
        });
    },

    saveCotizacionValores: async (data: {
        id_cotizacion: string;
        id_proveedor: string;
        items: { id_item: string; precio: number; cantidad: number; iva_porcentaje: number; subtotal: number; laboratorio?: string; codigo_cum?: string; nombre_comercial?: string; }[];
        flete?: number;
        descuento?: number;
        plazo_pago?: string;
        tiempo_entrega?: string;
        subtotal_general?: number;
        total_iva_general?: number;
        total_general?: number;
    }) => {
        return apiService.post('/cotizaciones/save/proveedor/detalle', data);
    },

    generarOrdenCompra: async (data: { id_cotizacion: string; id_proveedor: string; idbodega: string, user_crea: string }) => {
        return apiService.post('/ordenescompra/generar', data);
    },

    generarOrdenesCompraConsolidadas: async (data: any) => {
        return apiService.post('/ordenescompra/generar-consolidada', data);
    },

    getDetalleProveedor: async (idCotizacion: string, idProveedor: string) => {
        return apiService.get<any>('/cotizaciones/detalle/proveedor', true, {
            params: {
                id_cotizacion: idCotizacion,
                id_proveedor: idProveedor
            }
        });
    }
};
